/** localStorage that never breaks the app: blocked or empty storage falls back to the default (spec §4.5). */
export function readStored<T>(key: string, fallback: T, valid: (value: unknown) => boolean): T {
    try {
        const raw = globalThis.localStorage?.getItem(key)
        if (raw === null || raw === undefined) {
            return fallback
        }
        const value: unknown = JSON.parse(raw)
        return valid(value) ? (value as T) : fallback
    } catch {
        return fallback
    }
}

export function writeStored(key: string, value: unknown): void {
    try {
        globalThis.localStorage?.setItem(key, JSON.stringify(value))
    } catch {
        // storage blocked or full: the preference lasts for this page only
    }
}
